import PdfIcon from './pdf-icon'
import ExcelIcon from './excel-icon'
import WordIcon from './word-icon'
import DefaultIcon from './default-icon'

export const getFileIcon = (fileType: string) => {
  switch (fileType.toLowerCase()) {
    case 'pdf':
      return <PdfIcon />
    case 'xls':
    case 'xlsx':
    case 'xlsb':
    case 'xlsm':
      return <ExcelIcon />
    case 'doc':
    case 'docx':
      return <WordIcon />
    default:
      return <DefaultIcon />
  }
}
